import { render, staticRenderFns } from "./myBookingsPage.vue?vue&type=template&id=46523d5c&scoped=true&"
import script from "./myBookingsPage.vue?vue&type=script&lang=ts&"
export * from "./myBookingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./myBookingsPage.vue?vue&type=style&index=0&id=46523d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46523d5c",
  null
  
)

export default component.exports